var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Poste de travail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Bureau isometrique avec ecran et courbe de suivi.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 166.5 L 456.1 285.3 L 261.7 397.5 L 55.9 278.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 227.4 199.5 L 398.9 298.5 L 284.6 364.5 L 113.1 265.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 227.4 199.5 L 398.9 298.5 L 284.6 364.5 L 113.1 265.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 227.4,
    y1: 199.2,
    x2: 113.1,
    y2: 265.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 270.3,
    y1: 223.9,
    x2: 156,
    y2: 289.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 313.2,
    y1: 248.7,
    x2: 198.8,
    y2: 314.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 356,
    y1: 273.4,
    x2: 241.7,
    y2: 339.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 398.9,
    y1: 298.2,
    x2: 284.6,
    y2: 364.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 227.4,
    y1: 199.2,
    x2: 398.9,
    y2: 298.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 189.3,
    y1: 221.2,
    x2: 360.8,
    y2: 320.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 151.2,
    y1: 243.2,
    x2: 322.7,
    y2: 342.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 113.1,
    y1: 265.2,
    x2: 284.6,
    y2: 364.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 284.6 238.4 L 278.3 242.1 L 278.3 337.8 L 284.6 334.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 158.3 172.8 L 278.3 242.1 L 278.3 337.8 L 158.3 268.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 164.5 169.1 L 284.6 238.4 L 278.3 242.1 L 158.3 172.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 164.5,
    y1: 264.8,
    x2: 164.5,
    y2: 169.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 164.5,
    y1: 264.8,
    x2: 284.6,
    y2: 334.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 164.5,
    y1: 264.8,
    x2: 158.3,
    y2: 268.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 164.5 169.1 L 284.6 238.4 L 278.3 242.1 L 158.3 172.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 284.6,
    y1: 238.4,
    x2: 284.6,
    y2: 334.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 278.3,
    y1: 242.1,
    x2: 278.3,
    y2: 337.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 158.3,
    y1: 172.8,
    x2: 158.3,
    y2: 268.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 284.6,
    y1: 334.1,
    x2: 278.3,
    y2: 337.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 278.3,
    y1: 337.8,
    x2: 158.3,
    y2: 268.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 171.7 256.4 L 277.4 317.5 L 277.4 244.9 L 171.7 183.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 171.7 256.4 L 277.4 317.5 L 277.4 244.9 L 171.7 183.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a flow",
    d: "M 183.4 243.1 L 200 229.5 L 216.6 252.3 L 233.1 235.5 L 249.7 254.9 L 266.3 243.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 200,
    cy: 229.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 200,
    cy: 229.5,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d4",
    cx: 233.1,
    cy: 235.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 233.1,
    cy: 235.5,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d9",
    cx: 266.3,
    cy: 243.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 266.3,
    cy: 243.1,
    r: 3.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 318.9 288.6 L 287.4 306.8 L 287.4 312.7 L 318.9 294.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 201.7 257.2 L 287.4 306.8 L 287.4 312.7 L 201.7 263.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 233.1 239.1 L 318.9 288.6 L 287.4 306.8 L 201.7 257.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 245,
    x2: 233.1,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 245,
    x2: 318.9,
    y2: 294.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 245,
    x2: 201.7,
    y2: 263.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 233.1 239.1 L 318.9 288.6 L 287.4 306.8 L 201.7 257.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 318.9,
    y1: 288.6,
    x2: 318.9,
    y2: 294.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 287.4,
    y1: 306.8,
    x2: 287.4,
    y2: 312.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 201.7,
    y1: 257.2,
    x2: 201.7,
    y2: 263.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 318.9,
    y1: 294.5,
    x2: 287.4,
    y2: 312.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 287.4,
    y1: 312.7,
    x2: 201.7,
    y2: 263.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 378.9 253.3 L 353.2 268.1 L 353.2 320.9 L 378.9 306.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 327.4 253.3 L 353.2 268.1 L 353.2 320.9 L 327.4 306.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 353.2 238.4 L 378.9 253.3 L 353.2 268.1 L 327.4 253.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 353.2,
    y1: 291.2,
    x2: 353.2,
    y2: 238.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 353.2,
    y1: 291.2,
    x2: 378.9,
    y2: 306.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 353.2,
    y1: 291.2,
    x2: 327.4,
    y2: 306.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 353.2 238.4 L 378.9 253.3 L 353.2 268.1 L 327.4 253.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 378.9,
    y1: 253.3,
    x2: 378.9,
    y2: 306.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 353.2,
    y1: 268.1,
    x2: 353.2,
    y2: 320.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 327.4,
    y1: 253.3,
    x2: 327.4,
    y2: 306.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 378.9,
    y1: 306.1,
    x2: 353.2,
    y2: 320.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 353.2,
    y1: 320.9,
    x2: 327.4,
    y2: 306.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.9b8b028cc8ebda8c68971cd5da052812.svg";
export { ForwardRef as ReactComponent };